<h1 class="mb-4">
  <mdb-icon fas icon="cog"></mdb-icon> Histórico de Quiebres
</h1>
<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Reportes y Consulta</span>
      <span> /</span>
      <span class="grey-text">Ventas</span>
      <span> /</span>
      <span>Histórico de Quiebres</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de filtros -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-body">
        <!-- Fecha Desde -->
        <div class="col" style="max-width: 200px">
          <div class="md-form mb-0">
            <label for="fechaDesde">Desde:</label>
            <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Desde'" required
              formControlName="fechaDesde"></mdb-date-picker>
            <div
              *ngIf="formHeader.get('fechaDesde').invalid && (formHeader.get('fechaDesde').dirty || formHeader.get('fechaDesde').touched)">
              <mdb-error *ngIf="formHeader.get('fechaDesde').hasError('required')">Ingrese fecha desde</mdb-error>
            </div>
          </div>
        </div>

        <!-- Fecha Hasta -->
        <div class="col" style="max-width: 200px">
          <div class="md-form mb-0">
            <label for="fechaHasta">Hasta:</label>
            <mdb-date-picker [inline]="true" name="fechaHasta" [placeholder]="'Hasta'" required
              formControlName="fechaHasta"></mdb-date-picker>
            <div
              *ngIf="formHeader.get('fechaHasta').invalid && (formHeader.get('fechaHasta').dirty || formHeader.get('fechaHasta').touched)">
              <mdb-error *ngIf="formHeader.get('fechaHasta').hasError('required')">Ingrese fecha hasta</mdb-error>
            </div>
          </div>
        </div>

        <!-- SKU -->
        <div class="col" style="max-width: 150px">
          <div class="md-form mb-0">
            <input value="" type="text" id="sku" class="form-control" placeholder="000" #sku formControlName="sku" />
            <label for="sku">SKU</label>
          </div>
        </div>
        <div class="col d-flex">
          <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
            (click)="openModalSeleccionarProducto()">
            <mdb-icon fas icon="search"></mdb-icon>
          </button>
          <h6 class="text-info" style="display: contents;" *ngIf="productoSeleccionado">
            {{ productoSeleccionado.descripcion }}
          </h6>
        </div>
      </div>
      <div class="row"
        *ngIf="formHeader.get('fechaDesde').hasError('maxRangeDate') || formHeader.get('fechaHasta').hasError('maxRangeDate')">
        <div class="col-12">
          <small class="text-danger">El rango máximo de fechas es de 12 meses.</small>
        </div>
      </div>
    </div>

    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
      <div></div>
      <div>
        <button mdbBtn type="button" size="sm" color="secondary" mdbWavesEffect
          (click)="limpiarFiltros()">Limpiar</button>
        <button mdbBtn type="button" size="sm" color="secondary" mdbWavesEffect (click)="buscarReporte()">
          <mdb-icon fas icon="search"></mdb-icon> Buscar
        </button>
      </div>
    </div>
  </div>
</form>

<!-- Resultados -->
<div class="card mb-2 wow detalle-cliente" *ngIf="datosReporte !== null || loading">
  <div class="card-body justify-content-between">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th rowspan="2" scope="col">Cod. Producto</th>
            <th rowspan="2" scope="col">Descripción</th>
            <th colspan="2" scope="col" class="text-center">Demanda</th>
            <th colspan="2" scope="col" class="text-center">Demanda atendida</th>
            <th colspan="2" scope="col" class="text-center">Quiebres</th>
          </tr>
          <tr>
            <th class="text-center">Cajas</th>
            <th class="text-center">Fracción</th>
            <th class="text-center">Cajas</th>
            <th class="text-center">Fraccion</th>
            <th class="text-center">Cajas</th>
            <th class="text-center">Fracción</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="loading">
            <td colspan="8" style="text-align: center">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
          </tr>
          <tr *ngIf="!loading && datosReporteUnificado?.length === 0">
            <td colspan="8" style="text-align: center">
              No se encontró información
            </td>
          </tr>
          <tr *ngFor="let item of datosReporteUnificado">
            <td>{{item.sku}}</td>
            <td>{{item.nombreProducto}}</td>
            <td class="text-right">{{item.demandaCantidad | numerico}}</td>
            <td class="text-right">{{item.demandaFraccion | numerico}}</td>
            <td class="text-right">{{item.demandaAtendidaCantidad | numerico}}</td>
            <td class="text-right">{{item.demandaAtendidaFraccion | numerico}}</td>
            <td class="text-right">{{item.quiebreCantidad | numerico}}</td>
            <td class="text-right">{{item.quiebreFraccion | numerico}}</td>
          </tr>
        </tbody>
      </table>
      <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
        *ngIf="datosReporteUnificado?.length > 0"></app-pagination>
    </div>

    <!-- Totales -->
    <div class="table-responsive" *ngIf="datosReporte?.length > 0">
      <table class="table table-striped table-hover table-sm align-middle">
        <tbody>
          <tr>
            <td class="col-12" style="font-weight: bold; font-size: 15px;text-align: right;">
              <span style="color: red;">Total Quiebre: </span>
              <span>{{totalQuiebreCantidad | numerico}}</span>
              <span> / </span>
              <span>{{totalQuiebreFraccion | numerico}}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- Botones de acción -->
<div class="card mb-2 wow" *ngIf="datosReporte && datosReporte.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <div></div>
    <app-api-button [processing]="exportandoExcel" (click2)="exportarExcel()" color="success">
      <mdb-icon fas icon="file-excel"></mdb-icon> Exportar a Excel
    </app-api-button>
  </div>
</div>

<!-- MODAL seleccionarProducto -->
<app-modal-seleccionar-producto [showFiltroActivoInactivo]="false" (onSelect)="onProductoSeleccionado($event)"
  (onNotFound)="onProductoNoEncontrado()">
</app-modal-seleccionar-producto>